/**
 * Production-aware logger.
 * Suppresses noisy debug output in production builds while keeping it
 * available for local dev. Wraps console.error with a guard so we don't
 * leak debug info or hurt perf in the deployed app.
 */
const isDev = process.env.NODE_ENV !== "production";

export const logError = (msg, err) => {
    if (isDev) {
        // eslint-disable-next-line no-console
        console.error(msg, err);
    }
};

export const logWarn = (msg, err) => {
    if (isDev) {
        // eslint-disable-next-line no-console
        console.warn(msg, err);
    }
};

export default { logError, logWarn };
